import { UserPermissionType, UserRoleType } from 'redux/Constants/types';

export const hasPayoutAccess = (userRole: UserRoleType, userPermissionArray: Array<UserPermissionType>): boolean => {
  return userRole === 'admin' || userPermissionArray.includes('payouts-read');
};
